module.exports = __webpack_public_path__ + "img/control_de_calidad_16-9.bee19599.jpg";